import { render } from "./NoticeBlock.vue?vue&type=template&id=33465e9a"
import script from "./NoticeBlock.vue?vue&type=script&lang=js"
export * from "./NoticeBlock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kudamoi/projects/freedom/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__